import React from 'react'

interface DemoControlsButtonProps {
  label: string
  onClick: () => void | Promise<void>
}

export const DemoControlsButton = ({
  label,
  onClick,
}: DemoControlsButtonProps) => {
  return (
    <button className='admin-button' onClick={() => { void onClick() }}>
      {label}
    </button>
  )
}
